import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject, fromEvent, Subject } from 'rxjs';
import { takeUntil, debounceTime } from 'rxjs/operators';
import { ServiceRequestComponent } from '../components/service-request/service-request.component';

export interface Menu {
  headTitle1?: any;
  headTitle2?: string;
  path?: string;
  title?: any;
  icon?: string;
  type?: string;
  badgeType?: string;
  badgeValue?: string;
  active?: boolean;
  bookmark?: boolean;
  isServiceModule: boolean;
  isVIKModule: boolean;
  isGlobal: boolean;
  isEGovAutomation: boolean;
  children?: Menu[];
  onClick?:()=>void;
}
@Injectable({
  providedIn: 'root',
})
export class NavService {


  private unsubscriber: Subject<any> = new Subject();
  public screenWidth: BehaviorSubject<number> = new BehaviorSubject(
    window.innerWidth
  );

  // Search Box
  public search: boolean = false;

  // Language
  public language: boolean = false;

  // Collapse Sidebar
  public collapseSidebar: boolean = window.innerWidth < 991 ? true : false;

  // For Horizontal Layout Mobile
  public horizontal: boolean = window.innerWidth < 991 ? false : true;

  // Full screen
  public fullScreen: boolean = false;

  constructor(private router: Router,public serviceModal:NgbModal) {
    this.setScreenWidth(window.innerWidth);
    fromEvent(window, 'resize')
      .pipe(debounceTime(1000), takeUntil(this.unsubscriber))
      .subscribe((evt: any) => {
        this.setScreenWidth(evt.target.innerWidth);
        if (evt.target.innerWidth < 991) {
          this.collapseSidebar = true;
        }
        if (evt.target.innerWidth < 1199) {
        }
      });
    if (window.innerWidth < 991) {
      // Detect Route change sidebar close
      this.router.events.subscribe((event) => {
        this.collapseSidebar = true;
      });
    }
  }

  private setScreenWidth(width: number): void {
    this.screenWidth.next(width);
  }

  public onServiceRequestClick(){

    let modalRef= this.serviceModal.open(ServiceRequestComponent, { size: 'xl', centered: true,backdrop:'static' });
    modalRef.componentInstance.onClose.subscribe(r=>{
      console.log('r');
    });
  }

  MENUITEMS: Menu[] = [
    {
      headTitle1: 'Бързи Връзки',
      active: false,
      isServiceModule: false,
      isVIKModule: false,
      isGlobal:true,
      isEGovAutomation: true,  // Hide this header in eGov Automation mode
      type: 'link',
      bookmark: true,
    },
    {
      icon: 'clipboard',
      onClick:()=>this.onServiceRequestClick(),
      title: 'Заяви Услуга',
      active: false,
      isServiceModule: true,
      isVIKModule: false,
      isGlobal: false,
      isEGovAutomation: true,
      type: 'btn',
      bookmark: true,
    },
    {
      path: '/service/request/list',
      icon: 'clipboard',
      title: 'Преглед на Услуги',
      isVIKModule: false,
      active: false,
      isServiceModule: true,
      isGlobal:false,
      isEGovAutomation: true,
      type: 'link',
      bookmark: true,
    },
    {
      path: '/service/request/all',
      icon: 'clipboard',
      title: 'Заявени Услуги',
      isVIKModule: false,
      active: false,
      isServiceModule: true,
      isGlobal:false,
      isEGovAutomation: true,
      type: 'link',
      bookmark: true,
    },
    {
      headTitle1: 'Инструменти',
      isServiceModule: true,
      isVIKModule: true,
      isGlobal: true,
      isEGovAutomation: false,
    },
    {
      title: 'Сигнали',

      icon: 'clipboard',
      type: 'sub',
      active: false,
      isServiceModule: false,
      isVIKModule: true,
      isGlobal: false,
      isEGovAutomation: false,
      bookmark: true,
      children: [
        { path: '/vik/signals', title: 'Списък', type: 'link',
          isServiceModule: false, isVIKModule: true, isGlobal: false, isEGovAutomation: false },
        { path: '/vik/map', title: 'Карта', type: 'link',
           isServiceModule: false, isVIKModule: true, isGlobal: false, isEGovAutomation: false },
      ],
    },
    {
      title: 'Аварии',
      path: '/vik/emergencies',
      icon: 'clipboard',
      type: 'link',
      active: false,
      isServiceModule: false,
      isVIKModule: true,
      isGlobal: false,
      isEGovAutomation: false,
      bookmark: true
    },
    {
      title: 'Услуги',
      icon: 'archive',
      type: 'sub',
      badgeType: 'light-primary',
      badgeValue: '3',
      active: false,
      isServiceModule: true,
      isVIKModule: false,
      isGlobal: false,
      isEGovAutomation: true,
      children: [
        { path: '/service/request/list', title: 'Преглед на Заявки', type: 'link', isServiceModule: true, isVIKModule: false, isGlobal: false, isEGovAutomation: true },
        { path: '/service/request/all', title: 'Заявени Услуги', type: 'link', isServiceModule: true, isVIKModule: false, isGlobal: false, isEGovAutomation: true },
        { path: '/admin/services', title: 'Услуги', type: 'link', isServiceModule: true, isVIKModule: false, isGlobal: false, isEGovAutomation: false },
      ],
    },
    {
      title: 'Каса',
      icon: 'shopping-bag',
      type: 'sub',
      badgeType: 'light-primary',
      badgeValue: '2',
      active: false,
      isServiceModule: true,
      isVIKModule: false,
      isGlobal: false,
      isEGovAutomation: true,
      children: [
        { path: '/kasa', title: 'Преглед', type: 'link', isServiceModule: false, isVIKModule: false, isGlobal: false, isEGovAutomation: true },
        { path: '', title: 'Дневна Справка', type: 'link', isServiceModule: true, isVIKModule: false, isGlobal: false, isEGovAutomation: true },
        { path: '/tax/settlement', title: 'Разпределяне на Приходи', type: 'link', isServiceModule: true, isVIKModule: false, isGlobal: false, isEGovAutomation: true },
      ],
    },
    {
      headTitle1: 'Администрация',
      isServiceModule: false,
      isVIKModule: false,
      isGlobal: true,
      isEGovAutomation: false,
    },
    {
      path: '/admin/users',
      icon: 'users',
      title: 'Потребители',
      active: false,
      isServiceModule: false,
      isVIKModule: false,
      isGlobal: true,
      isEGovAutomation: false,
      type: 'link',
      bookmark: true,
    },
    {
      path: '/admin/orgs',
      icon: 'triangle',
      title: 'Организации',
      active: false,
      isServiceModule: false,
      isVIKModule: false,
      isGlobal: true,
      isEGovAutomation: false,
      type: 'link',
      bookmark: true,
    },
    {
      title: 'Номенклатури',
      icon: 'settings',
      type: 'sub',
      badgeType: 'light-primary',
      badgeValue: '2',
      active: false,
      isServiceModule: false,
      isVIKModule: false,
      isGlobal: true,
      isEGovAutomation: false,
      children: [
        { path: '/bank/accounts', title: 'Банкови Сметки', type: 'link', isServiceModule: true, isVIKModule: false, isGlobal: false, isEGovAutomation: false },
        { path: '/admin/services', title: 'Услуги', isServiceModule: true, type: 'link', isVIKModule: false, isGlobal: false, isEGovAutomation: false },
        { path: '/admin/agents', title: 'Посредници', isServiceModule: true, type: 'link', isVIKModule: false, isGlobal: false, isEGovAutomation: true },
        { path: '/admin/serviceProviders', title: 'Доставчици', isServiceModule: true, type: 'link', isVIKModule: false, isGlobal: false, isEGovAutomation: false },
        { path: '/admin/shippingMethods', title: 'Методи за Доставка', isServiceModule: true, type: 'link', isVIKModule: false, isGlobal: false, isEGovAutomation: false },
        { path: '/admin/documents', title: 'Документи', isServiceModule: true, type: 'link', isVIKModule: false, isGlobal: false, isEGovAutomation: false },
        { path: '/admin/documents/type', title: 'Документентни Типове', isServiceModule: true, type: 'link', isVIKModule: false, isGlobal: false, isEGovAutomation: false },
        { path: '/vik/workingGroups', title: 'Ремонтни групи', isServiceModule: false, type: 'link', isVIKModule: true, isGlobal: false, isEGovAutomation: false },
        { path: '/admin/profession', title: 'Професии', isServiceModule: true, type: 'link', isVIKModule: true, isGlobal: false, isEGovAutomation: false },
        { path: '/vik/nom/units', title: 'Мерни Единици', isServiceModule: false, type: 'link', isVIKModule: true, isGlobal: false, isEGovAutomation: false },
        { path: '/vik/nom/materials', title: 'Материали', isServiceModule: false, type: 'link', isVIKModule: true, isGlobal: false, isEGovAutomation: false },
        { path: '/vik/nom/mechanisation', title: 'Механизация', isServiceModule: false, type: 'link', isVIKModule: true, isGlobal: false, isEGovAutomation: false },
        { path: '/vik/nom/avariitype', title: 'Тип Аварии', isServiceModule: false, type: 'link', isVIKModule: true, isGlobal: false, isEGovAutomation: false },
      ],
    },
  ];

  items = new BehaviorSubject<Menu[]>(this.MENUITEMS);
}
